<!--
* @Name：流程审批-同意
* @Author: 刘玉
* @Date: 2021-12-17 16:56:42
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-17 16:56:42
-->
<template>
  <div class="component-overlay">
    <van-nav-bar
      class="text-font-normal"
      title="同意"
      left-arrow
      left-text="关闭"
      @click-left="onClickLeft"
      :fixed="true"
    />
    <van-form ref="form">
      <van-field label="下一个节点" class="nextNode">
        <template #input>
          <van-tag
            style="padding: 2px; font-size: 17px"
            type="success"
            v-for="item in form.nextNode"
            :key="item.taskName"
          >
            {{ item.taskName }}</van-tag
          >
        </template>
      </van-field>
      <van-field
        v-for="item in form.nextNode.filter(el => el.nodeType === 'userTask')"
        class="text-font-normal"
        :key="item.taskName"
        :label="item.taskName"
      >
        <template #input>
          <van-tag
            style="padding: 2px; font-size: 17px"
            type="success"
            v-for="(user, userIndex) in item.extObj"
            :key="userIndex"
          >
            {{ user.name }}</van-tag
          >
        </template>
      </van-field>
      <van-field
        class="text-font-normal"
        label="备注/意见"
        v-model="form.opinion"
        placeholder="请输入备注/意见"
        :autosize="{ minHeight: 100, maxHeight: 100 }"
        type="textarea"
        :rules="[{ required: true, message: '备注/意见为必填项' }]"
      />
    </van-form>
    <div style="text-align: center">
      <van-button size="normal" @click="cancel">取消</van-button>
      <van-button
        type="info"
        size="normal"
        :loading="loading"
        loading-text="加载中..."
        style="margin-left: 10px"
        @click="confirm"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
export default {
  name: 'Agree',
  data() {
    return {
      form: {
        action: 'agree',
        actionName: 'agree',
        formType: 'inner',
        nextNode: [],
        opinion: '同意'
      }
    }
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    taskId: {
      type: String,
      required: true,
      default: ''
    },
    taskTitle: {
      type: String,
      required: true,
      default: ''
    },
    nextNode: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  mounted() {
    this.form.taskId = this.taskId
    this.form.taskTitle = this.taskTitle
    this.form.nextNode = cloneDeep(this.nextNode)
  },
  methods: {
    confirm() {
      this.$refs.form.validate().then(() => {
        let nextNodeStr = ''
        let nextNodeStrUser = ''
        for (let i = 0; i < this.nextNode.length; i++) {
          nextNodeStr += this.nextNode[i].taskId
          if (i < this.nextNode.length - 1) {
            nextNodeStr += ','
          }

          if (this.form.nextNode[i].extObj) {
            for (let j = 0; j < this.form.nextNode[i].extObj.length; j++) {
              nextNodeStrUser += this.form.nextNode[i].extObj[j].username
              if (j < this.form.nextNode[i].extObj.length - 1) {
                nextNodeStrUser += ','
              }
            }
            if (this.form.nextNode.length > 1 && i < this.form.nextNode.length - 1) {
              nextNodeStrUser += '_'
            }
          }
        }
        this.form.chooseNode = nextNodeStr
        this.form.chooseNodeUser = nextNodeStrUser

        const data = JSON.parse(JSON.stringify(this.form))
        delete data.nextNode

        this.$emit('confirm', data)
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    onClickLeft() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.nextNode {
  margin: 48px 0 10px 0;
  font-size: 17px;
}
</style>
